import React, { useState } from 'react';
import ChartOfAccounts from './ChartOfAccounts';
import BankManagement from './BankManagement';
import TrialBalance from './TrialBalance';
import VoucherSystem from './VoucherSystem';
import AccountStatement from './AccountStatement';
import ReportsPanel from "./ReportsPanel";
import VoucherList from './VoucherList';

const AccountantPanel = ({ initialTab }) => {
    const [activeTab, setActiveTab] = useState(initialTab || 'coa');

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.tabBar}>
                <button 
                    style={activeTab === 'coa' ? styles.tabBtnActive : styles.tabBtn} 
                    onClick={() => setActiveTab('coa')}
                >🌳 Chart of Accounts</button>
                 <button 
                    style={activeTab === 'vouchers' ? styles.tabBtnActive : styles.tabBtn} 
                    onClick={() => setActiveTab('vouchers')}
                >📝 Voucher Entry</button>
               <button 
    style={activeTab === 'report' ? styles.tabBtnActive : styles.tabBtn} 
    onClick={() => setActiveTab('report')}
>
    📜  Report
</button>
<button 
    style={activeTab === 'voucherlist' ? styles.tabBtnActive : styles.tabBtn} 
    onClick={() => setActiveTab('voucherlist')}
>
    📋 Voucher List
</button>

            </div>
           

           <div style={styles.contentArea}>
                {activeTab === 'coa' && <ChartOfAccounts />}
                {activeTab === 'vouchers' && <VoucherSystem />}
                {activeTab === 'report' && <ReportsPanel />}
                {activeTab === 'voucherlist' && <VoucherList />}
            </div>
        </div>
    );
};

const styles = {
    mainWrapper: { padding: '20px', backgroundColor: '#f8fafc', borderRadius: '15px' },
    tabBar: { display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0' },
    tabBtn: { padding: '12px 20px', border: 'none', background: 'none', cursor: 'pointer', color: '#64748b', fontWeight: 'bold' },
    tabBtnActive: { padding: '12px 20px', border: 'none', borderBottom: '2px solid #10b981', background: 'none', cursor: 'pointer', color: '#10b981', fontWeight: 'bold' },
    contentArea: { background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    subPanel: { display: 'flex', flexDirection: 'column', gap: '20px' },
    formRow: { display: 'flex', gap: '15px' },
    formGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' },
    input: { padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0', outline: 'none' },
    btnPrimary: { background: '#334155', color: '#fff', border: 'none', borderRadius: '8px', padding: '0 20px', cursor: 'pointer' },
    btnSuccess: { background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px', cursor: 'pointer', fontWeight: 'bold' },
    table: { width: '100%', borderCollapse: 'collapse', marginTop: '20px' },
    bankGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginTop: '20px' },
    bankCard: { padding: '15px', border: '1px solid #f1f5f9', borderRadius: '12px', background: '#f8fafc' },
    editBtn: { border: 'none', color: '#3b82f6', background: 'none', cursor: 'pointer', padding: 0, fontSize: '12px', fontWeight: 'bold' }
};

export default AccountantPanel;